<script lang="ts" setup>
import BasicButton from '~/components/form-elements/BasicButton.vue'
import CustomModalWindow from '~/components/modal-windows/CustomModalWindow.vue'
import { DiscountType } from '~/enums/discount-type'

const model = defineModel<boolean>()

const props = defineProps<{
  currentDiscountType: DiscountType
  newDiscountType: DiscountType
}>()

const emit = defineEmits<{
  (e: 'confirmDiscountSelection', x: DiscountType): void
}>()

const text = computed(
  () => {
    switch (props.currentDiscountType) {
      case DiscountType.Points:
        return 'Отменить списание баллов iTAB Плюс?'
      case DiscountType.PromoCode:
        return 'Отменить применение промокода?'
      case DiscountType.SuperminsPoints:
        return 'Отменить списание баллов Supermins?'
      default:
        return null
    }
  }
)

function close (): void {
  model.value = false
}

function confirmDiscountSelection () {
  emit('confirmDiscountSelection', props.newDiscountType)

  close()
}
</script>

<template>
  <CustomModalWindow v-model="model">
    <template #title>
      Подтверждение выбора скидки
    </template>

    <Notification class="mb-6" is-small status="warning">
      {{ text }}
    </Notification>

    <BasicButton color="green" title="Да, отменить" @click="confirmDiscountSelection" />

    <template #action>
      <a href="#" @click.prevent="close">Закрыть</a>
    </template>
  </CustomModalWindow>
</template>
